<div id="assessment-container" class="assess-wrapper">
    <div class="assess-header">
        <div class="assess-title">
            <span translate>teacher.lilate.assessment.title </span><span class="examinee-name">{{lilate.student.user.first_name}} {{lilate.student.user.last_name}}</span>
        </div>
        <div class="subnav">
            <div class="subnav-elem subnav-id" (click)="scroll('id-check-anchor')"><span class="subnav-icon"></span><span class="subnav-title" translate>teacher.lilate.assessment.subnav.id</span></div>
            <div class="subnav-elem subnav-global" (click)="scroll('global-level-assessment-anchor')"><span class="subnav-icon"></span><span class="subnav-title" translate>teacher.lilate.assessment.subnav.global</span></div>
            <div class="subnav-elem subnav-convers" (click)="scroll('conversation-level-assessment-anchor')"><span class="subnav-icon"></span><span class="subnav-title" translate>teacher.lilate.assessment.subnav.Convers</span></div>
            <div class="subnav-elem subnav-reading" (click)="scroll('reading-level-assessment-anchor')"><span class="subnav-icon"></span><span class="subnav-title" translate>teacher.lilate.assessment.subnav.Reading</span></div>
            <div class="subnav-elem subnav-listening" (click)="scroll('listening-level-assessment-anchor')"><span class="subnav-icon"></span><span class="subnav-title" translate>teacher.lilate.assessment.subnav.Listening</span></div>
            <div class="subnav-elem subnav-writing" (click)="scroll('writing-level-assessment-anchor')"><span class="subnav-icon"></span><span class="subnav-title" translate>teacher.lilate.assessment.subnav.Writing</span></div>
            <div class="subnav-elem subnav-speaking" (click)="scroll('speaking-level-assessment-anchor')"><span class="subnav-icon"></span><span class="subnav-title" translate>teacher.lilate.assessment.subnav.Speaking</span></div>
        </div>
    </div>
    <div id="id-check" class="assess-id">
        <div id="id-check-anchor" class="nav-anchor"></div>
        <div class="category-title">
            <span class="category-icon"></span>
            <span translate>teacher.lilate.assessment.id-check.title</span>
        </div>
        <div class="id-wrapper">
            <div class="id-pic" *ngIf="lilate.student.user.photo_profile">
                <img src="{{lilate.student.user.photo_profile.photo_identity}}" alt="identity_picture">
            </div>
            <div class="id-infos">
                <div translate>
                    teacher.lilate.assessment.last_name <span>{{lilate.student.user.last_name}}</span>
                </div>
                <div translate>
                    teacher.lilate.assessment.first_name <span>{{lilate.student.user.first_name}}</span>
                </div>
                <div translate>
                    teacher.lilate.assessment.birthdate <span>{{lilate.student.user.birthdate | amLocale: 'en' | amDateFormat:'DD MMMM YYYY'}}</span>
                </div>
            </div>
        </div>
        <div class="id-actions-wrap">
            <div class="report-issue-wrap" translate>
                <span translate>
                    teacher.lilate.assessment.report-issue.abs-student
                </span>
                <mat-radio-group aria-label="Select an option" [(ngModel)]="student_abs">
                    <mat-radio-button [value]="false">Oui</mat-radio-button>
                    <mat-radio-button [value]="true">Non</mat-radio-button>
                  </mat-radio-group>
            </div>

            <div class="report-issue-wrap" *ngIf="!student_abs" translate>
                <span translate>
                    teacher.lilate.assessment.report-issue.photo-no-conform                    
                </span>
                <mat-radio-group aria-label="Select an option" [(ngModel)]="photo_profile_issue">
                    <mat-radio-button [value]="false">Oui</mat-radio-button>
                    <mat-radio-button [value]="true">Non</mat-radio-button>
                  </mat-radio-group>
            </div>

            <div class="report-issue-wrap" *ngIf="!student_abs" translate>
                <span translate>
                    teacher.lilate.assessment.report-issue.identity-issue
                </span>
                <mat-radio-group aria-label="Select an option" [(ngModel)]="identity_issue">
                    <mat-radio-button [value]="false">Oui</mat-radio-button>
                    <mat-radio-button [value]="true">Non</mat-radio-button>
                  </mat-radio-group>
            </div>

            <div class="report-issue-wrap error" *ngIf="!student_abs && (student_abs === null || photo_profile_issue === null || identity_issue === null)" translate>
                teacher.lilate.assessment.issue-error
            </div>

            <button class="report-issue-btn" *ngIf="student_abs" (click)="reportIssueLilate()" translate>teacher.lilate.assessment.report-issue.btn</button>
        </div>
        <div class="assess-category-footer"></div>
    </div>
    <div *ngIf="!student_abs" class="assess-content">
        <div id="{{rubrique.slug}}" class="assess-category {{rubrique.slug}}" *ngFor="let rubrique of grid">
            <div class="nav-anchor" id="{{rubrique.slug}}-anchor"></div>
            <div class="category-title">
                <!--<span class="category-icon"></span>-->
                <span>{{rubrique.description_fr}}</span>
            </div>
            <div class="level-options-wrap">
                <div class="level-option" *ngFor="let level of rubrique.childrens"
                    [ngClass]="{'activated-level' : treeInfos[rubrique.id].id === level.id}"
                    (click)="getSkills(level.id, level.label_fr, rubrique.id)">
                    {{level.label_fr}}
                </div>
            </div>
            <div class="skills-wrap" *ngIf="rubrique.id !== globalId">
                <div class="skills-title"><span translate>teacher.lilate.assessment.skills-title</span></div>
                <div class="skill-content" *ngFor="let skill of treeInfos[rubrique.id].skills" [ngClass]="{'activated-skill' : skill.selected}"
                    (click)="selectSkill(skill.id, rubrique.id)">
                    {{skill.label_fr}}
                </div>
            </div>
            <div class="error" *ngIf="treeInfos[rubrique.id].skills.length > 0 && !treeInfos[rubrique.id].skillSelected && rubrique.id !== globalId" translate>
                teacher.lilate.assessment.skills-error
            </div>
            <div class="assess-category-footer"></div>
        </div>

        <div class="assess-category">
            <div class="recap-title"><span translate>teacher.lilate.assessment.recap-title</span></div>
            <div class="recap-subwrap">
                <div class="recap-category" *ngFor="let rubrique of grid">
                    <span *ngIf="rubrique.id !== globalId">
                        {{rubrique.description_fr}}: <span *ngIf="treeInfos[rubrique.id] && treeInfos[rubrique.id].level">{{treeInfos[rubrique.id].level}}</span><span class="missing-category" *ngIf="treeInfos[rubrique.id] && !treeInfos[rubrique.id].level">?</span>
                    </span> 
                </div>
            </div>
            <div class="recap-global" translate>teacher.lilate.assessment.recap-level <span class="recap-global-level" *ngIf="globalId && treeInfos[globalId].level"> {{ treeInfos[globalId].level }}</span></div>

            <button class="submit-assessment-btn" (click)="postassessment()" [disabled]="saveProcessing">
                <span *ngIf="!saveProcessing" translate>teacher.lilate.assessment.recap-btn</span>
                <span *ngIf="saveProcessing" translate>teacher.lilate.assessment.save-processing</span>
            </button>
        </div>
    </div>
</div>
